import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import bindMethods from 'auto-bind';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

import ApplicationLayout from '../layouts/ApplicationLayout';
import FormField from '../components/FormField';
import FormSubmitButton from '../components/FormSubmitButton';
import { passwordResetEmail } from '../api/sso';
import ActionButton from '../components/ActionButton';

import { ReactComponent as SuccessImage } from '../images/ok.svg';

const EmailSentMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    height: 60px;
    margin-bottom: 10px;
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
    color: ${props => props.theme.WHITE};
  }

  p {
    width: 250px;
    font-size: 18px;
    font-weight: 500;
    color: ${props => props.theme.WHITE};
    text-align: center;
  }
`;

class ForgotPasswordPage extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.state = {
      displaySuccess: false,
      email: '',
    };
  }

  handleBackToLoginClick() {
    const { history } = this.props;
    history.push('/login');
  }

  async handleFormSubmit(event) {
    const { email } = this.state;
    event.preventDefault();

    try {
      await passwordResetEmail(email);
      this.setState({
        displaySuccess: true,
      });
    } catch (error) {
      console.error(error);
    }
  }

  handleInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  renderForm() {
    const { t } = this.props;
    const { email } = this.state;

    return (
      <form id="SSO.ForgotPassword.Form" onSubmit={this.handleFormSubmit}>
        <FormField
          inputId="SSO.ForgotPassword.Email"
          name="email"
          type="email"
          value={email}
          placeholder={t('Placeholders.Email')}
          onChange={this.handleInputChange}
        />

        <FormSubmitButton id="SSO.ForgotPassword.Submit">
          {t('ForgotPassword.Headline')}
        </FormSubmitButton>
      </form>
    );
  }

  renderMessage() {
    const { t } = this.props;

    return (
      <EmailSentMessageContainer>
        <SuccessImage id="SSO.ForgotPassword.SuccessImage" alt={t('ForgotPassword.SuccessMessage.Headline')} />
        <h1 id="SSO.ForgotPassword.SuccessMessage.Headline">{t('ForgotPassword.SuccessMessage.Headline')}</h1>
        <p id="SSO.ForgotPassword.SuccessMessage.Text">{t('ForgotPassword.SuccessMessage.Text')}</p>
        <ActionButton id="SSO.ForgotPassword.BackToLoginButton" onClick={this.handleBackToLoginClick}>
          {t('ForgotPassword.BackButtonText')}
        </ActionButton>
      </EmailSentMessageContainer>
    );
  }

  render() {
    const { t, branding } = this.props;
    const { displaySuccess } = this.state;

    return (
      <ApplicationLayout branding={branding} formHeadline={t('ForgotPassword.Headline')} displayFormHeadline={!displaySuccess}>
        {!displaySuccess ? this.renderForm() : this.renderMessage()}
      </ApplicationLayout>
    );
  }
}

ForgotPasswordPage.propTypes = {
  history: PropTypes.object.isRequired, // supplied from React Router
  t: PropTypes.func.isRequired, // supplied from withTranslation
  branding: PropTypes.string.isRequired,
};

export default withTranslation()(ForgotPasswordPage);
